@if (_info) {
  <mat-card class="modern-dashboard-card" *ngIf="!_isLoading">
    <!-- Header Section -->
    <div class="dashboard-header">
      <div class="header-content">
        <ddc-text-gradient [_icon]="'dashboard'" [_text]="'Dashboard'" [_type]="'1'"></ddc-text-gradient>
      </div>
    </div>

    <!-- Stats Section -->
    <div class="stats-section">
      <div class="stats-grid">
        <!-- Social Stats -->
        <div class="stat-group">
          <div class="stat-item">
            <ddc-button-n-one
              [_hasBorder]="false"
              [_icon]="'person'"
              [_label]="'Followers: ' + _info.followers.length"
              (click)="dashboardElementClicked('followers')"
            ></ddc-button-n-one>
            <ddc-button-n-one
              [_hasBorder]="false"
              [_icon]="'perm_identity'"
              [_label]="'Following: ' + _info.following.length"
              (click)="dashboardElementClicked('following')"
            ></ddc-button-n-one>
          </div>
          <div class="stat-item">
            <ddc-button-n-one
              [_hasBorder]="false"
              [_icon]="'fiber_manual_record'"
              [_label]="'Words: ' + _info.words_count"
              (click)="dashboardElementClicked('words')"
            ></ddc-button-n-one>
            <ddc-button-n-one
              [_hasBorder]="false"
              [_icon]="'fiber_smart_record'"
              [_label]="'Pairs: ' + _info.pairs_count"
              (click)="dashboardElementClicked('pairs')"
            ></ddc-button-n-one>
          </div>
          <div class="stat-item">
            <ddc-button-n-one
              [_hasBorder]="false"
              [_icon]="'auto_stories'"
              [_label]="'Dictionaries: ' + _info.dics_count"
              (click)="dashboardElementClicked('dics')"
            ></ddc-button-n-one>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Actions Section -->
    <div class="dashboard-header quick-access-header">
      <div class="header-content">
        <ddc-text-gradient [_icon]="'arrow_forward'" [_text]="'Quick Access'" [_type]="'1'"></ddc-text-gradient>
      </div>
    </div>

    <!-- Stats Section -->
    <div class="stats-section">
      <div class="stats-grid">
        <!-- Social Stats -->
        <div class="stat-group">
          <div class="stat-item">
            <ddc-button-n-one
              [_dynamicRoute]="'/saved'"
              [_hasBorder]="false"
              [_icon]="'bookmark'"
              [_label]="'Collections'"
            ></ddc-button-n-one>
          </div>
          <div class="stat-item">
            <ddc-button-n-one
              [_hasBorder]="false"
              [_icon]="'category'"
              [_label]="'Categories'"
              (click)="dashboardElementClicked('cats')"
            ></ddc-button-n-one>
            <ddc-button-n-one
              [_hasBorder]="false"
              [_icon]="'tag'"
              [_label]="'Tags'"
              (click)="dashboardElementClicked('tags')"
            ></ddc-button-n-one>
          </div>
        </div>
      </div>
    </div>

    <!-- AI Agents Status Section -->
    <!-- <div class="dashboard-header ai-agents-header">
      <div class="header-content">
        <ddc-text-gradient [_icon]="'smart_toy'" [_text]="'AI Agents'" [_type]="'1'"></ddc-text-gradient>
      </div>
    </div> -->

    <!-- AI Agents Status -->
    <!-- <div class="ai-agents-section">
      <div class="agents-grid">
        <div class="agent-card" *ngFor="let agent of _dummyAgents; let i = index">
          <div class="agent-info">
            <div class="agent-icon">
              <mat-icon>{{ agent.icon }}</mat-icon>
            </div>
            <div class="agent-details">
              <div class="agent-name">{{ agent.name }}</div>
              <div class="agent-status">
                <span
                  class="status-indicator"
                  [class.status-busy]="agent.status === 'busy'"
                  [class.status-offline]="agent.status === 'offline'"
                  [class.status-online]="agent.status === 'online'"
                ></span>
                <span class="status-text">{{ agent.status | titlecase }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </mat-card>
}
